import { Button, Modal, Select } from "antd";
import { qaTypeButtons } from "../../constant";
import { chunkArray } from "../../utils/spliter";

const Assign = ({
  open,
  handleCancel,
  showLoading,
  qaList,
  OnSelect,
  QATYPE,
  onChange,
  onSearch,
}) => {
  const buttonRows = chunkArray(qaTypeButtons, 2);

  return (
    <Modal
      title={
        <div className="container-fluid d-flex flex-column align-items-center text-center">
          <div className="d-flex justify-content-start flex-column w-100 mb-2">
            <div className="d-flex justify-content-center align-items-center assing-icon-css">
              <i className="bi bi-people icon"></i>
            </div>
            {/* <div className="d-flex justify-content-start mt-3">
              <span className="fs-5 fw-semibold">Assign QA</span>
            </div> */}
          </div>
        </div>
      }
      open={open}
      onCancel={handleCancel}
      footer={
        <div className="assign-bottom-btn-css">
          <Button key="cancel" onClick={handleCancel} className="footer-btn-css">
            Cancel
          </Button>
          <Button key="confirm" onClick={showLoading} className="footer-btn-1-css">
            Confirm
          </Button>
        </div>
      }
      width={750}
    >
      <div className="container-fluid">
        <div className="d-flex flex-column mt-2">
          {/* <p className="text-css">Select QA Type (Single Select)</p> */}

          {/* Dynamically render 2 buttons per row */}
          {/* {buttonRows.map((row, rowIndex) => (
            <div
              key={`row-${rowIndex}`}
              style={{
                display: "flex",
                gap: "8px",
                marginTop: rowIndex === 0 ? "20px" : "10px",
              }}
            >
              {row.map((btn) => (
                <Button
                  key={btn.id}
                  onClick={() => OnSelect(btn.id)}
                  style={{
                    flex: 1,
                    background: QATYPE === btn.id ? "#052659" : "transparent",
                    color: QATYPE === btn.id ? "#FFFFFF" : "#000",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  {btn.label}
                </Button>
              ))}
            </div>
          ))} */}

          <p className="text-css">Select QA</p>
          <div style={{ display: "flex", gap: "8px", marginTop: "10px" }}>
            <Select
              showSearch
              className="select-QA"
              placeholder="Search by name, phone number, or keywords"
              optionFilterProp="label"
              onChange={onChange}
              onSearch={onSearch}
              options={qaList}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Assign;
